/**
 * @generated SignedSource<<8c0719812a4405f5c9118a4b3988b39f>>
 * @relayHash 718e597ad464f46a24b791e6bf652462
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8fccef6ab3cb5673806e075732ffd08639dc6ce58f6dcc5a2aa460ff5c6906b8

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_DigestsNotificationsPageQuery$variables = {
  cloudId: string;
};
export type ui_DigestsNotificationsPageQuery$data = {
  readonly jira: {
    readonly notificationGlobalPreference: {
      readonly preferences: {
        readonly dailyDueDateNotification: {
          readonly emailChannel: {
            readonly isEnabled: boolean | null | undefined;
          } | null | undefined;
          readonly inProductChannel: {
            readonly isEnabled: boolean | null | undefined;
          } | null | undefined;
          readonly slackChannel: {
            readonly isEnabled: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly projectInviterNotification: {
          readonly emailChannel: {
            readonly isEnabled: boolean | null | undefined;
          } | null | undefined;
          readonly inProductChannel: {
            readonly isEnabled: boolean | null | undefined;
          } | null | undefined;
          readonly slackChannel: {
            readonly isEnabled: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_emailFragment" | "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment" | "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_slackFragment" | "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_emailPreferenceFragment" | "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment" | "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment" | "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification" | "emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification" | "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification" | "inProductPrefDueDateNotif_personalSettingsDigestNotifications_InProductPrefDueDateNotification" | "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification" | "slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification">;
      } | null | undefined;
    };
  };
};
export type ui_DigestsNotificationsPageQuery = {
  response: ui_DigestsNotificationsPageQuery$data;
  variables: ui_DigestsNotificationsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  }
],
v3 = {
  "concreteType": "JiraNotificationChannel",
  "kind": "LinkedField",
  "name": "emailChannel",
  "plural": false,
  "selections": (v2/*: any*/)
},
v4 = {
  "concreteType": "JiraNotificationChannel",
  "kind": "LinkedField",
  "name": "inProductChannel",
  "plural": false,
  "selections": (v2/*: any*/)
},
v5 = {
  "concreteType": "JiraNotificationChannel",
  "kind": "LinkedField",
  "name": "slackChannel",
  "plural": false,
  "selections": (v2/*: any*/)
},
v6 = [
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  (v7/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_DigestsNotificationsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v1/*: any*/),
                "concreteType": "JiraNotificationGlobalPreference",
                "kind": "LinkedField",
                "name": "notificationGlobalPreference",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_emailPreferenceFragment"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_inProductPreferenceFragment"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "combinedPrefDueDateNotif_personalSettingsDigestNotifications_CombinedPrefDueDateNotification_slackPreferenceFragment"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "emailPrefDueDateNotif_personalSettingsDigestNotifications_EmailPrefDueDateNotification"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "inProductPrefDueDateNotif_personalSettingsDigestNotifications_InProductPrefDueDateNotification"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "slackPrefDueDateNotif_personalSettingsDigestNotifications_SlackPrefDueDateNotification"
                      },
                      {
                        "concreteType": "JiraNotificationPreference",
                        "kind": "LinkedField",
                        "name": "dailyDueDateNotification",
                        "plural": false,
                        "selections": (v6/*: any*/)
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_emailFragment"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_inProductFragment"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "combinedInviterNotif_personalSettingsDigestNotifications_CombinedInviterNotification_slackFragment"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "emailInviterNotif_personalSettingsDigestNotifications_EmailInviterNotification"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "inProductInviterNotif_personalSettingsDigestNotifications_InProductInviterNotification"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification"
                      },
                      {
                        "concreteType": "JiraNotificationPreference",
                        "kind": "LinkedField",
                        "name": "projectInviterNotification",
                        "plural": false,
                        "selections": (v6/*: any*/)
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.notificationGlobalPreference"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_DigestsNotificationsPageQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraNotificationGlobalPreference",
            "kind": "LinkedField",
            "name": "notificationGlobalPreference",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "dailyDueDateNotification",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "dailyDueDateNotification",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "projectInviterNotification",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8fccef6ab3cb5673806e075732ffd08639dc6ce58f6dcc5a2aa460ff5c6906b8",
    "metadata": {},
    "name": "ui_DigestsNotificationsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "356cbe93acea3ef0af461e142cbd1e38";

export default node;
